import { SessionTimeoutModalComponent } from '../modals/session-timeout-modal/session-timeout-modal.component';
import { TechnicalErrorModalComponent } from '../modals/technical-error-modal/technical-error-modal.component'
import { IModalConfig } from "../../../shared/modules/bs-modal/interfaces/modal-config.interface";

export const TechnicalError: IModalConfig = { content: TechnicalErrorModalComponent, options: { ignoreBackdropClick: true }, type: "TechnicalError" };
export const SessionTimeout: IModalConfig = { content: SessionTimeoutModalComponent, options: { class: 'timeout-popup' }, type: "SessionTimeout" };
